import http from "./http";
import { buildUrlFromLocation } from "@/utils/httpUtils";
import httpService from "@/components/service";
import Globals from "@/components/globals";

export default {
    async getList() {
        return await http.get(buildUrlFromLocation("/help", { campaignId: null }));
    },
    async uploadPdf(file, appId, name, idHelp = null) {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("id", idHelp);
        formData.append("name", name);
        return await http.post(buildUrlFromLocation(`/help/upload-pdf/${appId}`, { campaignId: null }), formData, null, true);
    },
    async uploadLink(link, name, appId, idHelp = null) {
        return await http.post(buildUrlFromLocation(`/help/upload-link/${appId}`, { campaignId: null }), { link: link, name: name, id: idHelp });
    },
    async delete(idHelp) {
        return await http.post(buildUrlFromLocation(`/help/help-delete/${idHelp}`, { campaignId: null }));
    }
};



// WEBPACK FOOTER //
// ./src/services/help.js